import { Col, Row, Image, Offcanvas, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableComp from "../component/Table";
import { useCallback, useEffect, useState } from "react";
import { HiPhone } from "react-icons/hi2";
import LinkDriverList from "../component/LinkDriverList";
import GoalAchievedCard from "../component/GoalAchievedCard";
import { MdEmail } from "react-icons/md";
import { t } from "i18next";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import SessionUtil from "../util/SessionUtil";
import FormDriver from "../component/FormDriver";
import Pagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import ReactLoading from "react-loading";

const CustomRow = ({ rowData, columnNames, handleShow }) => {
  const lang = SessionUtil.getLang();
  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td key={index} onClick={() => handleShow(rowData)}>
          {columnName === "driverId" ? (
            <span>#{rowData.Id}</span>
          ) : columnName === "DeliveryName" ? (
            <div className="flex-gap-2">
              {rowData?.DriverImage ? (
                <div className="dimension-40">
                  <Image
                    alt="image"
                    src={rowData.DriverImage}
                    className="img-fluid"
                  />
                </div>
              ) : (
                <span className="img-empty"></span>
              )}
              <p className="mb-0">
                {lang === "en" || rowData.DriverNameAr === ""
                  ? rowData?.DriverNameEn
                  : rowData?.DriverNameAr}
              </p>
            </div>
          ) : columnName === "DeliveryPhone" ? (
            <div className="flex-gap-2">
              <HiPhone size={16} color={"#3A974C"} />{" "}
              <p className="mb-0">
                {"+" + rowData.AreaCode + "" + rowData.PhoneNumber}
              </p>
            </div>
          ) : columnName === "deliverEmail" ? (
            <div className="flex-gap-2">
              <MdEmail size={16} color="#4285F4" />{" "}
              <p className="mb-0">{rowData.Email}</p>{" "}
            </div>
          ) : columnName === "Status" ? (
            <div className="status status-warning">
              <p className="mb-0">{t("Pending")}</p>
            </div>
          ) : (
            // rowData.Status === '1' ? <div className="accept-reject">{t('Accept')}</div> : <div className="accept-reject">{t('Reject')}</div>
            <p className="mb-0">{rowData[columnName]}</p>
          )}
        </td>
      ))}
    </tr>
  );
};

const DriverRegistrationRequest = () => {
  const { t } = useTranslation();
  const columnNames = [
    "driverId",
    "DeliveryName",
    "DeliveryPhone",
    "deliverEmail",
    "Status",
  ];
  const [sortedData, setSortedData] = useState([]);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [validated, setValidated] = useState(false);
  const [status, setStatus] = useState(null);
  const [alertMsg, setAlertMsg] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [msgError, setMsgError] = useState("");

  const isLoggedIn = SessionUtil.isLoggedIn(); // Custom hook or context

  const handleClose = () => {
    setShow(false);
    setValidated(false);
    setLoadingSubmit(false);
  };

  const handleShow = (data) => {
    setShow(true);
    setStatus(null);
    setRowData(data);
  };

  const getDriverApi = useCallback(async () => {
    let data = {
      PageNumber: currentPage,
      PageSize: "10",
      OrderBy: "Id Desc",
      DriversView: {
        StatusCode: "PENDING",
      },
    };
    const res = await ApiUtil.postApi(ApiPath.GET_ALL_DRIVERS, data, "POST");
    if (res.IsSuccessfull) {
      setSortedData(res.Result.Driver);
      const totalPage = Math.ceil(res.Result.RecordCount / 10);
      setRecordCount(totalPage);
      setLoading(false);
    }
  }, [currentPage]);
  useEffect(() => {
    if (isLoggedIn) {
      getDriverApi();
    }
  }, [getDriverApi, isLoggedIn]);

  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
     setMsgError("");


    if (status) {
      approvalDriver();
      setShow(false);
      setValidated(false);
    } else {
      setMsgError(t("Please select a status (Accept or Reject)."));
      return;
    }
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
  };
  const approvalDriver = async () => {
    setLoadingSubmit(true);
    let params = {
      DriverId: rowData.Id,
      ActionName: status,
    };
    const res = await ApiUtil.postApi(ApiPath.APPROVAL_DRIVER, params, "POST");
    if (res.IsSuccessfull) {
      setLoadingSubmit(false);
      getDriverApi();
      setCurrentPage(1);
      setAlertMsg(true);
      setTimeout(() => {
        setAlertMsg(null);
      }, 5000);
    } else {
      setAlertMsg(false);
      setLoadingSubmit(false);
    }
  };
  return (
    <>
      <Row className="g-0">
        {!loading ? (
          <>
            <Col lg={8} className="position-relative">
              <div className=" mt-4 d-flex justify-content-between gap-2">
                <p className="title">{t("Driver Registration request")}</p>
              </div>
              {alertMsg !== null &&
                (alertMsg ? (
                  <Alert variant={"success"} className="mt-3">
                    {status === "Approval"
                      ? t("Driver approved successfully")
                      : t("Driver rejected successfully")}
                    .
                  </Alert>
                ) : (
                  <Alert variant={"danger"} className="mt-3">
                    {t("There is an error in the process")}.
                  </Alert>
                ))}
              <TableComp
                data={sortedData}
                columnNames={columnNames}
                setSortedData={setSortedData}
                // handleSelectAll={handleSelectAll} isChecked={isCheckAll} handleDelete={handleDelete}
              >
                {sortedData.map((rowData, index) => (
                  <CustomRow
                    key={index}
                    rowData={rowData}
                    columnNames={columnNames}
                    // handleClick={handleCheckbox} isChecked={isCheck.includes(rowData.Id)} handleStar={handleStar}
                    handleShow={handleShow}
                  />
                ))}
              </TableComp>
              <Pagination
                current={currentPage}
                total={recordCount}
                onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
                extraClassName="justify-content-end"
              />
            </Col>

            <Col md={1}>
              <div className="divider-vertical mx-auto"></div>
            </Col>
            <Col lg={3} className="mt-5">
              {/* <Search /> */}
              <LinkDriverList data={[]} type="linkDriver" />
              <GoalAchievedCard />
            </Col>
          </>
        ) : (
          <Col lg={12} className="loading-style">
            <ReactLoading
              type={"bars"}
              color={"#c8c8c8"}
              height={"50px"}
              width={"50px"}
            />
          </Col>
        )}
      </Row>
      <Offcanvas placement="end" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{t("Driver Information")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <FormDriver
            rowData={rowData}
            handleStatus={handleStatus}
            validated={validated}
            handleSubmit={handleSubmit}
            loadingSubmit={loadingSubmit}
            msgError={msgError}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DriverRegistrationRequest;
